export default __webpack_public_path__ + "static/media/6.7463d573.png";